<template><div><h1>VUX V2.1.0Rc.48 released</h1>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul></ul>
<h2><a href="/en/components/debounce.html">Debounce</a></h2>
<ul></ul>
<h2><a href="/en/components/throttle.html">Throttle</a></h2>
<ul></ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.48 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.48-71.vue?a08eee2e